module.exports = __webpack_public_path__ + "img/loader_mBank_icon.b0c4d013.gif";